let apiReady;

const loadApi = () => {
  apiReady ??= new Promise((resolve) => {
    if (window.YT?.Player) {
      resolve(window.YT);
      return;
    }

    window.onYouTubeIframeAPIReady = () => resolve(window.YT);
    const script = document.createElement('script');
    script.src = 'https://www.youtube.com/iframe_api';
    document.head.append(script);
  });

  return apiReady;
};

export default class HoverAudio {
  constructor() {
    this.items = [...document.querySelectorAll('[data-hover-youtube]')].map((el) => {
      const host = document.createElement('div');
      host.setAttribute('aria-hidden', 'true');
      host.style.cssText = 'position:fixed;left:-9999px;width:1px;height:1px;overflow:hidden';
      const target = document.createElement('div');
      host.append(target);
      document.body.append(host);

      const from = Number(el.dataset.hoverStart) || 0;
      let player;
      let warm = false;
      let hovering = false;

      const create = () => loadApi().then((YT) => {
        player = new YT.Player(target, {
          videoId: el.dataset.hoverYoutube,
          playerVars: { controls: 0, playsinline: 1, start: from },
          events: {
            onReady: () => {
              player.mute();
              player.playVideo();
            },
            onStateChange: (event) => {
              if (event.data === YT.PlayerState.PLAYING && !warm) {
                warm = true;
                player.unMute();

                if (!hovering) {
                  player.pauseVideo();
                  player.seekTo(from, true);
                }
              }

              if (event.data === YT.PlayerState.ENDED && hovering) {
                player.seekTo(from);
                player.playVideo();
              }
            },
          },
        });
      });

      const idle = window.requestIdleCallback ?? ((fn) => setTimeout(fn, 300));
      const cancelIdle = window.cancelIdleCallback ?? clearTimeout;
      const idleId = idle(create, { timeout: 1500 });

      const start = (event) => {
        if (event.pointerType !== 'mouse') {
          return;
        }

        hovering = true;
        player?.playVideo?.();
      };
      const stop = () => {
        hovering = false;

        if (warm) {
          player.pauseVideo();
          player.seekTo(from, true);
        }
      };

      el.addEventListener('pointerenter', start);
      el.addEventListener('pointerleave', stop);
      el.addEventListener('click', stop);
      window.addEventListener('blur', stop);

      return { el, host, idleId, cancelIdle, start, stop, getPlayer: () => player };
    });
  }

  destroy() {
    this.items.forEach(({ el, host, idleId, cancelIdle, start, stop, getPlayer }) => {
      cancelIdle(idleId);
      el.removeEventListener('pointerenter', start);
      el.removeEventListener('pointerleave', stop);
      el.removeEventListener('click', stop);
      window.removeEventListener('blur', stop);
      getPlayer()?.destroy?.();
      host.remove();
    });
    this.items = [];
  }
}
